import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { FaPlus, FaTimes } from 'react-icons/fa';
import FormInput from '../form/FormInput';
import './StepProjectDetails.css';

const StepShootLocations = ({ control, fields, append, remove, handlePincodeLookup, projectIdToEdit }) => (
    <div className="animate-fade-in project-mobile-location">
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-section-title mb-0 border-0">Shoot Locations</div>
            <Button variant="outline-danger" size="sm" onClick={() => append({ id: '', pkid: projectIdToEdit || '', projectid: projectIdToEdit || '', pincode: '', addressLine1: '', addressLine2: '', state: '', district: '' })}>
                <FaPlus className="me-1" /> Add Location
            </Button>
        </div>

        {fields.map((item, index) => (
            // <div key={item.id} className="location-box mb-4 p-4 border border-secondary rounded position-relative bg-dark">
            <div key={item.id} className="location-box border border-secondary rounded position-relative bg-dark">
                {/* <div className="d-flex justify-content-between mb-3"> */}
                <div className="flex-between ">
                    <span className="badge bg-danger">Location #{index + 1}</span>
                    {fields.length > 1 && <Button variant="link" className="text-danger p-0" onClick={() => remove(index)}><FaTimes size={18} /></Button>}
                </div>
                <Controller name={`locations.${index}.id`} control={control} render={({ field }) => <input type="hidden" {...field} />} />

                {/* <Row className="g-3"> */}
                <Row className='location-row'>
                    <Col md={3}><FormInput name={`locations.${index}.addressLine1`} label="Shoot Location" control={control} /></Col>
                    <Col md={3}><FormInput name={`locations.${index}.state`} label="State" control={control} /></Col>
                    <Col md={3}><FormInput name={`locations.${index}.district`} label="District" control={control} /></Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="form-label">Pin Code</Form.Label>
                            <Controller name={`locations.${index}.pincode`} control={control} render={({ field }) => (
                                <Form.Control {...field} maxLength={6} placeholder="6-digit Pin" className="custom-form-input"
                                    onChange={(e) => {
                                        field.onChange(e); 
                                        if (e.target.value.length === 6) handlePincodeLookup(e.target.value, index);
                                    }}
                                />
                            )} />
                        </Form.Group>
                    </Col>
                </Row>
                {/* <Row className="g-3 mt-1"> */}
                <Row className='location-row-add'>
                    <Col md={3}><FormInput name={`locations.${index}.addressLine2`} label="Address 2" control={control} hidden /></Col>
                </Row>
            </div>
        ))}
    </div>
);

export default StepShootLocations;